module.exports = __webpack_public_path__ + "static/edit-carousel-for-videos-5526f89359dcc673ee0761f6db4197a1.png";